import { gql } from '@apollo/client';

export const getAttachmentUploadUrlForUserMutation = gql`
  mutation GetAttachmentUploadUrlForUser(
    $attachment: GetAttachmentUploadUrlRequest!
  ) {
    getAttachmentUploadUrlForUser(attachment: $attachment) {
      url
      fields
    }
  }
`;

export const saveAttachmentForUserMutation = gql`
  mutation SaveAttachmentForUser($attachment: SaveAttachmentInput!) {
    saveAttachmentForUser(attachment: $attachment) {
      _id
      desc
      s3Key
      size
      filename
      contentType
      tags
      url
      uploaded
      processed
      attachedTo
      createdBy
      updatedBy
      createdAt
      updatedAt
    }
  }
`;

export const saveProfilePhotoForUserMutation = gql`
  mutation SaveProfilePhotoForUser($profilePhoto: SaveProfilePhotoInput!) {
    saveProfilePhotoForUser(profilePhoto: $profilePhoto) {
      _id
      desc
      s3Key
      size
      filename
      contentType
      tags
      url
      uploaded
      processed
      profilePhotoFor
      createdBy
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
